/**
 * Brand facts. One place for every claim the site makes about Karijeeva,
 * so copy on different pages can never drift apart. Only add a fact here
 * once the company can show proof of it.
 */

export const BRAND = {
  name: "Karijeeva",
  company: "Kadle Global Pvt Ltd",
  fssai: "11226304000242",
  batchesTested: "500+",
  // Pressed from dried copra, so FSSAI "coconut oil" (not "virgin coconut oil").
  process: "Pressed cold from dried copra, with the temperature controlled so no heat is added.",
  support: { email: "support@karijeeva.in", phone: "+91 80504 40583", tel: "+918050440583" },
  origins: [
    {
      key: "tiptur",
      name: "Tiptur",
      region: "Tumakuru district, Karnataka",
      share: "Most of our coconuts",
      line: "Inland Karnataka, a town India has long known for its coconuts. Most of what we press grows here.",
    },
    {
      key: "coast",
      name: "Gokarna to Shirali",
      region: "Uttara Kannada coast, Karnataka",
      share: "Our coastal farms",
      line: "A stretch of the Karnataka coast from Gokarna down to Shirali near Bhatkal, where palms grow in sea air and monsoon rain.",
    },
  ],
};

/**
 * Latest lab report received from the company. Nutrition values per 100 g.
 * Replace with each new report; keep the reference number exact.
 */
export const LAB = {
  name: "Kemya Laboratory",
  city: "Belagavi, Karnataka",
  credential: "ISO 9001:2015 certified",
  url: "https://www.kemyalab.com",
  // Only claim NABL accreditation once a NABL certificate number is on file.
};

// Latest reports: Kemya Laboratory, sample received 19 Sep 2026, analysed
// 19 to 26 Sep 2026, issued 28 Sep 2026. The sample (600 ml, sealed plastic
// bottle) was sent to the lab by us, as the report states ("collected by: client").
export const LAB_REPORT = {
  ref: "KEML/2026/09/FD/490(A)-01",
  issued: "2026-09-28",
  received: "2026-09-19",
  analysed: "19 to 26 September 2026",
  sample: "600 ml in a sealed plastic bottle, sent to the lab by us",
  rows: [
    { param: "Energy", unit: "kcal", value: "894", method: "In house" },
    { param: "Total fat", unit: "g", value: "99.1", method: "FSSAI manual" },
    { param: "Saturated fat", unit: "g", value: "89.5", method: "AOAC 996.06" },
    { param: "Monounsaturated fat", unit: "g", value: "7.4", method: "AOAC 996.06" },
    { param: "Polyunsaturated fat", unit: "g", value: "2.1", method: "AOAC 996.06" },
    { param: "Trans fat", unit: "g", value: "<0.1", method: "AOAC 996.06" },
    { param: "Cholesterol", unit: "mg", value: "0.0", method: "AOAC 994.10" },
    { param: "Total carbohydrates", unit: "g", value: "0.5", method: "In house" },
    { param: "Protein", unit: "g", value: "0.0", method: "IS 7219:2010" },
    { param: "Fibre", unit: "g", value: "0.0", method: "FSSAI manual" },
  ],
};
// Karijeeva's own fatty acid profile, % of total fatty acids. Fill in from
// the lab's AOAC 996.06 fatty acid results (ask Kemya for the full profile of
// the report above). While lauric is null, the site says the figure is pending.
export const FATTY_ACIDS = {
  ref: null,        // e.g. "KEML/2026/09/FD/490(A)-01"
  lauric: null,     // C12:0, e.g. "48.2"
  myristic: null,   // C14:0
  caprylic: null,   // C8:0
  capric: null,     // C10:0
  palmitic: null,   // C16:0
};

export const PURITY_REPORT = {
  ref: "KEML/2026/09/FD/490(A)-02",
  issued: "2026-09-28",
  received: "2026-09-19",
  analysed: "19 to 26 September 2026",
  sample: "600 ml in a sealed plastic bottle, sent to the lab by us",
  standard: "FSSAI standard for coconut oil (FSSR 2011, 2.2.1(1))",
  conforms: true,
  rows: [
    { param: "Butyro refractometer reading at 40°C", value: "34.8", limit: "34.0 to 35.5", plain: "How the oil bends light. Other oils mixed in shift this reading." },
    { param: "Saponification value", value: "254", limit: "Not less than 250", plain: "Coconut oil is rich in medium chain fatty acids such as lauric acid, so this number is high. Cheaper oils mixed in pull it down." },
    { param: "Iodine value", value: "8.1", limit: "7.5 to 10", plain: "A measure of unsaturated fat. Most other cooking oils score far higher, so blending pushes it up." },
    { param: "Unsaponifiable matter", value: "0.5%", limit: "Not more than 1.0%", plain: "Material that isn't oil. Mineral oil and waxes raise it." },
    { param: "Acid value", value: "4.7", limit: "Not more than 6.0", plain: "Free fatty acids, a sign of how well the copra was dried and stored. Lower is better." },
    { param: "Argemone oil test", value: "Negative", limit: "Must be negative", plain: "Argemone is a toxic seed oil that has been used to adulterate edible oils in India." },
  ],
};

